import MatchCard from './MatchCard.vue';
import MatchCardList from './MatchCardList.vue';
export default {
  MatchCard,
  MatchCardList,
};
